import { useMemo } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { save, get } from "../../services/localStorageService";
import { getResponsiblesState } from "../../selectors/responsiblesSelectors";

export default function useCalendarFiltersByDashboard() {
  const responsibles = useSelector(getResponsiblesState);
  const DATE_FORMAT = "YYYY-MM-DD";

  const getPropertyFromLocalStorage = get("calendarFiltersByDashboard");

  const hasCalendarDashboardFilters = getPropertyFromLocalStorage != null;

  const prepareResponsibles = (queryDTO: { userFilter: { selected: string | any[]; }; }) => {
    if (queryDTO.userFilter.selected.length === 0)
      return responsibles.map((r: { id: any; }) => r.id);
    return queryDTO.userFilter.selected;
  };

  const prepareQueryToCalendarContext = ({ queryDTO }: { queryDTO: any }) =>
    JSON.stringify({
      preparedRange: {
        currentDate: queryDTO.start,
        currentListViewRange: {
          display: "Definir período",
          from: queryDTO.start,
          to: queryDTO.end
        }
      },
      lastView: "list",
      tags: queryDTO.tags,
      queryDTO: {
        appointmentSelected: queryDTO.appointmentSelected,
        deadlineSelected: queryDTO.deadlineSelected,
        hearingSelected: queryDTO.hearingSelected,
        taskSelected: queryDTO.taskSelected,
        status: queryDTO.status,
        userFilter: {
          ...queryDTO.userFilter,
          selected: prepareResponsibles(queryDTO)
        }
      }
    });

  const goToCalendarWithDashboardFilters = (query: { queryDTO: any; }, path: string | URL) => {
    const openPath = () => {
      setTimeout(() => {
        window.open(path, "_self");
      }, 300);
    };

    save("calendarFiltersByDashboard", prepareQueryToCalendarContext(query));
    openPath();
  };

  // eslint-disable-next-line consistent-return
  const calendarFiltersByDashboard = useMemo(() => {
    if (hasCalendarDashboardFilters) {
      const rawCalendarFiltersByDashboard = JSON.parse(
        getPropertyFromLocalStorage
      );
      const { preparedRange, queryDTO } = rawCalendarFiltersByDashboard;
      const isStatusOverdue = ["LATE", "OVERDUE"].includes(queryDTO.status);

      return {
        ...rawCalendarFiltersByDashboard,
        queryDTO: {
          ...queryDTO,
          status: isStatusOverdue ? "IN_PROGRESS" : queryDTO.status
        },
        preparedRange: {
          currentDate: moment(preparedRange.currentDate, DATE_FORMAT),
          currentListViewRange: {
            display: preparedRange.currentListViewRange.display,
            from: moment(preparedRange.currentListViewRange.from, DATE_FORMAT),
            to: moment(preparedRange.currentListViewRange.to, DATE_FORMAT),
            customFrom: moment(
              preparedRange.currentListViewRange.from,
              DATE_FORMAT
            ),
            customTo: moment(preparedRange.currentListViewRange.to, DATE_FORMAT)
          },
          isCustomListViewRangeSelected: true
        }
      };
    }
  }, [getPropertyFromLocalStorage, hasCalendarDashboardFilters]);

  const removeDashboardFilters = () => {
    if (hasCalendarDashboardFilters) {
      localStorage.removeItem("calendarFiltersByDashboard");
    }
  };

  return {
    hasCalendarDashboardFilters,
    calendarFiltersByDashboard,
    goToCalendarWithDashboardFilters,
    removeDashboardFilters
  };
}
